import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecordsNotFoundComponent } from '@shared/components/records-not-found/records-not-found.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [RecordsNotFoundComponent],
	imports: [CommonModule, TranslateModule],
	exports: [RecordsNotFoundComponent],
})
export class RecordsNotFoundModule {}
